const DocumentFormat = Object.freeze({
  DOCUMENT: 'DOCUMENT',
  SENTENCE: 'SENTENCE'
})
export default DocumentFormat
// RESERVE BELOW
